import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  .info-list {
    display: flex;
    flex-direction: column;
    list-style: none;

    gap: 16px;

    li {
      display: flex;
      align-items: center;
      gap: 8px;
      color: var(--black-7);
      font-weight: 500;
      font-size: 14px;
    }
  }

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Header = styled.div`
  height: 270px;
  width: 100%;
  padding: 20px 30%;
  position: relative;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: 20px;
    background: var(--white-darker);
  }

  @media (max-width: 800px) {
    padding: 0;
    height: auto;

    > img {
      border-radius: 0;
    }
  }
`;

export const LoadingHeader = styled.div`
  height: 250px;
  width: 100%;
  padding: 20px 30%;

  > div {
    height: 100%;
    width: 100%;
  }

  @media (max-width: 800px) {
    padding: 0;

    > div {
      border-radius: 0;
    }
  }
`;

export const IconContainer = styled.button`
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  background: var(--black-transparent);
  cursor: pointer;
  outline: none;
  transition: box-shadow 0.2s ease-in-out;

  :focus {
    box-shadow: 0 0 0px 3px rgba(0, 0, 0, 0.2);
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const Title = styled.h2`
  font-weight: bold;
  font-size: 36px;
  margin-right: 20px;
  line-height: 120%;
  color: var(--primary);
  margin-bottom: 24px;

  display: flex;
  align-items: center;
`;

interface DescriptionProps {
  active?: boolean;
}

export const Description = styled.p<DescriptionProps>`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: ${props => (props.active ? 'var(--info)' : 'var(--gray-9)')};
  margin-left: 15px;
`;

export const Spec = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: var(--black-5);
  margin-left: 15px;
`;

export const Card = styled.div`
  width: 100%;
  background: var(--white-darker);
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  margin-top: 40px;
  border-radius: 8px;

  label {
    font-weight: 500;
    font-size: 14px;
    color: var(--gray-9);
    text-transform: uppercase;
    margin: 0 0 20px 16px;
  }
`;

export const BlueLink = styled.span`
  font-weight: 500;
  font-size: 16px;
  color: var(--info);
  display: flex;
  align-items: center;
  flex: none;
  cursor: pointer;
`;

interface IconProps {
  owner?: boolean;
}

export const UserIcon = styled.img<IconProps>`
  min-height: 60px;
  min-width: 60px;
  max-height: 60px;
  max-width: 60px;
  border-radius: 50%;
  object-fit: cover;
  background: var(--gray-c);

  ${props =>
    props.owner &&
    css`
      border: 4px solid var(--warning);
    `}
`;

export const AnimalIcon = styled.div`
  height: 80px;
  width: 80px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--gray-c);
`;

export const AnimalCountRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 30px;

  > button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: 0;
    padding: 12px;
    border-radius: 8px;
    transition: background 0.2s ease;
    cursor: pointer;

    :hover {
      background: rgba(0, 0, 0, 0.05);
    }

    > span {
      font-weight: 500;
      color: var(--info);
      font-size: 14px;
      text-transform: uppercase;
    }
  }
`;

export const AnimalCount = styled.p`
  font-weight: bold;
  font-size: 30px;
  color: var(--info);
`;
